import { TAttraction } from "../attractions";
import { MEXICO_PROVINCES } from "_common/regions/regions";
import { ATTRACTION_TYPE } from "_common/attractions/type/attraction.type";

export const nayaritAttraction: TAttraction[] = [
    {
        name: "Playa Novillero",
        region: MEXICO_PROVINCES.NAYARIT,
        coordinates: {
            lat: 22.3709454,
            lng: -105.6829546,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Bahía Matanchen",
        region: MEXICO_PROVINCES.NAYARIT,
        coordinates: {
            lat: 21.5019523,
            lng: -105.2058731,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Miramar",
        region: MEXICO_PROVINCES.NAYARIT,
        coordinates: {
            lat: 21.4367179,
            lng: -105.1938018,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
];
